export default __webpack_public_path__ + "static/media/featured.cc55ae2a.jpg";